import styles from "./verdicts.module.css";

export interface ReportSummaryProps {
  /** Number of distinct verdict groups with discrepancies. */
  groupCount: number;
  /** Total discrepancy tickets across all groups. */
  totalDiscrepancies: number;
  /** Tickets already marked resolved. */
  resolvedCount: number;
}

/** A compact counts strip above the verdict groups (discrepancy / resolved). */
export function ReportSummary({
  groupCount,
  totalDiscrepancies,
  resolvedCount,
}: ReportSummaryProps) {
  const open = totalDiscrepancies - resolvedCount;
  return (
    <div className={styles.summary}>
      <div className={styles.stat}>
        <span className={`${styles.statValue} ${open > 0 ? styles.statValueDanger : ""}`}>
          {open}
        </span>
        <span className={styles.statLabel}>Open discrepancies</span>
      </div>
      <div className={styles.stat}>
        <span className={styles.statValue}>{groupCount}</span>
        <span className={styles.statLabel}>
          {groupCount === 1 ? "Verdict" : "Verdicts"}
        </span>
      </div>
      <div className={styles.stat}>
        <span className={`${styles.statValue} ${resolvedCount > 0 ? styles.statValueSuccess : ""}`}>
          {resolvedCount}
        </span>
        <span className={styles.statLabel}>Resolved</span>
      </div>
    </div>
  );
}
